import React from 'react';

interface InstagramIconProps {
  className?: string;
}

function InstagramIcon({ className }: InstagramIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g fill="currentColor" clipPath="url(#clip0)">
        <path d="M15.985 4.704c-.038-.85-.175-1.435-.372-1.941a3.9 3.9 0 0 0-.926-1.419 3.9 3.9 0 0 0-1.415-.922C12.761.225 12.18.088 11.33.05 10.474.01 10.202 0 8.03 0S5.586.01 4.732.047c-.85.037-1.434.175-1.94.372a3.9 3.9 0 0 0-1.42.925A3.9 3.9 0 0 0 .45 2.76C.253 3.27.116 3.85.078 4.7c-.04.857-.05 1.13-.05 3.302s.01 2.444.047 3.297c.038.85.175 1.435.372 1.941.203.538.519 1.019.925 1.42.4.405.885.721 1.416.921.51.197 1.091.335 1.941.372.853.038 1.126.047 3.298.047s2.444-.01 3.297-.047c.85-.037 1.435-.175 1.941-.372a4.1 4.1 0 0 0 2.341-2.34c.197-.51.335-1.092.372-1.942.038-.853.047-1.125.047-3.297s-.003-2.445-.04-3.298m-1.441 6.533c-.035.781-.166 1.203-.275 1.484a2.65 2.65 0 0 1-1.52 1.52c-.28.109-.706.24-1.484.274-.844.038-1.097.047-3.232.047s-2.391-.01-3.232-.047c-.781-.034-1.203-.165-1.485-.275a2.5 2.5 0 0 1-.918-.597 2.5 2.5 0 0 1-.597-.919c-.11-.28-.241-.706-.275-1.484-.038-.844-.047-1.097-.047-3.232s.009-2.391.047-3.232c.034-.781.165-1.203.275-1.485a2.4 2.4 0 0 1 .6-.919c.26-.265.572-.469.919-.597.28-.109.706-.24 1.484-.275.844-.037 1.097-.047 3.232-.047 2.138 0 2.391.01 3.232.047.781.035 1.203.166 1.485.275.347.128.662.332.919.597.265.26.468.572.597.92.109.28.24.706.275 1.484.037.844.047 1.097.047 3.232s-.01 2.385-.047 3.229"></path>
        <path d="M8.03 3.891a4.111 4.111 0 0 0 0 8.22 4.111 4.111 0 0 0 0-8.22m0 6.777a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334m5.232-6.938a.96.96 0 1 1-1.919-.001.96.96 0 0 1 1.92 0z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default InstagramIcon;
